import { Component, input } from '@angular/core';

export type CameraState = 'healthy' | 'unhealthy';

@Component({
  selector: 'app-pan-video-status',
  templateUrl: './pan-video-status.component.html',
  styleUrl: './pan-video-status.component.scss',
  standalone: false,
})
export class PanVideoStatusComponent {
  public status = input.required<CameraState>();
}
